var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Label',{attrs:{"tipo":_vm.tipo,"estilo":_vm.definirEstilo(_vm.codigo),"texto":_vm.definirSituacao(_vm.codigo)}})
}
var staticRenderFns = []

export { render, staticRenderFns }